import { lazy } from 'react';
const ConfirmEmail = lazy(() => import('./ConfirmEmail'));
const Login = lazy(() => import('./Login'));
const ForgotPassword = lazy(() => import('./ForgotPassword'));
const ResetPassword = lazy(() => import('./ResetPassword'));
const SignUp = lazy(() => import('./SignUp'));
const Handspring = lazy(() => import('./Handspring'));
const HTSSignUp = lazy(() => import('./HTSSignUp'));
const HTSProfileSetup = lazy(() => import('./HTSProfileSetup'));
const ProfileSetup = lazy(() => import('./ProfileSetup'));
const SitePersonalization = lazy(() => import('./SitePersonalization'));
const PaymentRequired = lazy(() => import('./PaymentRequired'));
const LoginWithToken = lazy(() => import('./LoginWithToken'));
const UseApp = lazy(() => import('./UseApp'));
const SignUpWithPurchase = lazy(() => import('./SignUpWithPurchase'));
const RedirectToDocument = lazy(() => import('./RedirectToDocument'));

export {
  ConfirmEmail,
  Login,
  ForgotPassword,
  ResetPassword,
  SignUp,
  Handspring,
  HTSSignUp,
  HTSProfileSetup,
  ProfileSetup,
  SitePersonalization,
  PaymentRequired,
  LoginWithToken,
  UseApp,
  SignUpWithPurchase,
  RedirectToDocument,
};

// export { default as ConfirmEmail } from './ConfirmEmail';
// export { default as Login } from './Login';
// export { default as ForgotPassword } from './ForgotPassword';
// export { default as ResetPassword } from './ResetPassword';
// export { default as SignUp } from './SignUp';
// export { default as Handspring } from './Handspring';
// export { default as HTSSignUp } from './HTSSignUp';
// export { default as HTSProfileSetup } from './HTSProfileSetup';
// export { default as ProfileSetup } from './ProfileSetup';
// export { default as SitePersonalization } from './SitePersonalization';
// export { default as PaymentRequired } from './PaymentRequired';
// export { default as LoginWithToken } from './LoginWithToken';
// export { default as UseApp } from './UseApp';
// export { default as SignUpWithPurchase } from './SignUpWithPurchase';
// export { default as RedirectToDocument } from './RedirectToDocument';
